import React from 'react';

const Features = () => {
  const featuresList = [
    {
      icon: '&#128736;',
      title: 'Custom-Made',
      description: 'Our solutions are specially designed for small to medium-sized manufacturing companies that need affordable yet powerful ERP systems.'
    },
    {
      icon: '&#128200;',
      title: 'Local Compliance',
      description: 'Built-in support for Dutch, Belgian, and Luxembourg regulations, ensuring you\'re always compliant.'
    },
    {
      icon: '&#128640;',
      title: 'Rapid Implementation',
      description: 'Operational within 2-4 weeks with minimal disruption to your daily business operations.'
    },
    {
      icon: '&#128101;',
      title: 'Expert Support',
      description: 'Our team consists of former production engineers who know your industry inside and out.'
    },
    {
      icon: '&#128187;',
      title: 'Cloud or On-premise',
      description: 'Flexible deployment options that fit your IT strategy, with seamless integration.'
    },
    {
      icon: '&#128176;',
      title: 'Affordable',
      description: 'Transparent pricing without hidden costs, with subscriptions tailored to your needs.'
    }
  ];

  return (
    <section className="features" id="features">
      <div className="container">
        <div className="section-title">
          <h2>Why Choose Skyline?</h2>
          <p>Our software is designed with the specific needs of manufacturing companies in the Benelux region in mind.</p>
        </div>
        <div className="features-grid">
          {featuresList.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon" dangerouslySetInnerHTML={{ __html: feature.icon }}></div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;